module.exports = __webpack_public_path__ + "static/media/logo-prefeitura.63a8f05b.png";